import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

const errorBoxShadow = '0 0 6px #f8b9b7';
const focusBoxShadow =
  'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)';

const InputStyled = styled.input`
  width: 100%;
  height: 3.15rem;
  padding: 0 2.15rem 0 1.07rem;
  border-radius: 0.29rem;
  font-family: ${({ theme }) => theme.fonts.default};
  font-size: 1rem;
  display: block;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  color: #555;
  outline: none;
  background: ${({ error, theme }) =>
    error ? theme.colors.backgroundDanger : '#fff'};
  border: ${({ error, theme }) =>
    error ? `1px solid ${theme.colors.borderDanger}` : '1px solid #ccc'};

  &::placeholder {
    color: #999;
    font-size: 1.15rem;
    opacity: 1;
  }

  &:focus {
    background: #fff;
    border-color: ${({ error, theme }) =>
      error ? theme.colors.borderDanger : '#66afe9'};
    box-shadow: ${({ error }) => (error ? errorBoxShadow : focusBoxShadow)};
  }
`;

const Input = forwardRef((props, ref) => {
  return <InputStyled ref={ref} {...props} />;
});

export { Input };
